export default {
    setVolunteerData(state, payload) {
        state.volunteerData = payload;
        state.volunteerDataResolved = true;
    },
    resetVolunteerDataResolved(state) {
        state.volunteerDataResolved = false;
    },
    setTeamMembers(state, payload) {
        state.teamMembers = payload;
    },
    setVolunteers(state, payload) {
        state.volunteers = payload;
    }
}